module.exports = __webpack_public_path__ + "img/vpdr7_greyhound_racing.9cef390e.png";